module.exports = __webpack_public_path__ + "img/sudoku_explanation_3.815c763f.png";